import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { id } from '../../../../filters/options/order-status';
import { orderStatusOptions } from '../../../../filters/options/order-status/options';
import { isOperator } from '../../../../filters/operators/collection';

import { AdvancedSearchOrderContext } from '../../context';
import MultiSelectDropdown from '../../../components/multi-select-dropdown';
import messages from '../messages';

import style from '../../../style.module.less';

const OrderStatusFilter = ({ shouldSendFocusToInput = false }) => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);
  const { value: values = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedOrderStatuses = values.map((val) => orderStatusOptions.find((opt) => opt.apiKey === val));

  const onOptionClicked = useCallback(
    (option) => {
      const optionIndex = values.findIndex((opt) => opt === option.apiKey);

      const value = optionIndex >= 0 ? [...values.slice(0, optionIndex), ...values.slice(optionIndex + 1)] : [...values, option.apiKey];

      updateFilter(id, value, isOperator);
    },
    [updateFilter, values],
  );

  const getLabel = () => {
    if (selectedOrderStatuses.length === 0) {
      return <FormattedMessage {...messages.any} />;
    }

    if (selectedOrderStatuses.length === 1) {
      return selectedOrderStatuses[0].component;
    }

    return (
      <FormattedMessage
        {...messages.multiSelection}
        values={{
          count: selectedOrderStatuses.length,
          total: orderStatusOptions.length,
        }}
      />
    );
  };

  return (
    <span className={style.filterInput}>
      <label className={style.filterLabel}>
        <FormattedMessage {...messages.orderStatus} />
      </label>
      <MultiSelectDropdown
        label={getLabel()}
        onOptionClicked={onOptionClicked}
        options={orderStatusOptions}
        selectedOptions={selectedOrderStatuses}
        shouldSendFocusToInput={shouldSendFocusToInput}
      />
    </span>
  );
};

OrderStatusFilter.propTypes = {
  shouldSendFocusToInput: PropTypes.bool,
};

export default OrderStatusFilter;
